<template>
    <div>
        <!-- Modal Marcar Bloco -->
        <div class="modal fade" id="marcarBlocoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Marcar Pacientes</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">Marcar {{ lista.filter(item => item.selecionado).length }}/{{ lista.length }} paciente(s)</div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    placeholder="Selecione a Unidade..."
                                    type="select"
                                    icon="fa fa-building fa-fw"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="novo.id_unidade_operacao" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Manter Horários"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="novo.mesmo_horario" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    placeholder="Selecione o Procedimento..."
                                    icon="fas fa-play fa-fw"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    service="procedimentos.index"
                                    optionsDisplay="search"
                                    :optionsParm="{ ativos: 1 }"
                                    :optionsSync="true"
                                    v-model="novo.procedimento"
                                    required 
                                    :validate="validate"
                                    ref="info_procedimento">

                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="novo && novo.procedimento && novo.procedimento.id_classe_procedimento == 1">
                                            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ traduzir_tipo_consulta(novo.tipo_consulta) }}
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('C')">-</a>
                                                <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('I')">Inicial</a>
                                                <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('P')">Pré-Natal</a>
                                                <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('R')">Revisão</a>
                                                <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('S')">Subsequente</a>
                                            </div>
                                        </div>
                                    </template>

                                </az-input>
                            </div>

                            <div class="col col-12 col-md-6">

                                <az-input
                                    sizing="sm"
                                    placeholder="Profissional..."
                                    icon="fas fa-briefcase-medical fa-fw"
                                    type="autocomplete"
                                    service="medicos.index"
                                    optionsDisplay="st_nome_exibicao"
                                    :optionsSync="true"
                                    v-model="novo.medico"
                                    required 
                                    :validate="validate"
                                    ref="info_medico" />

                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    placeholder="Data"
                                    icon="fas fa-calendar-alt fa-fw"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="novo.data" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input   
                                    sizing="sm"
                                    placeholder="Hora"
                                    icon="fa-regular fa-clock fa-fw"
                                    type="time"
                                    required 
                                    v-if="!novo.mesmo_horario"
                                    :validate="validate"
                                    v-model="novo.hora" />
                            </div>
                        </div>

                        

                        <table class="table table-sm table-hover mt-3">
                            <tr v-for="(item, index) in lista" :key="index">
                                <td>
                                    <input type="checkbox" v-model="item.selecionado">
                                </td>
                                <td>{{ item.nome_paciente }}</td>
                                <td>{{ item.nome_procedimento }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="marcar()">Marcar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            lista: [], 
            novo: { 
                procedimento: "",
                tipo_consulta: 'C', 
                medico: "", 
                data: "",
                hora: "",
                id_unidade_operacao: "", 
            }, 
            validate: false, 
        }
    },

    components: {
        AzInput,
        AzSubmit
    },

    methods: { 
        traduzir_tipo_consulta (tipo) { 
            switch (tipo) {
                case 'R': return 'Revisão';
                case 'I': return 'Inicial';
                case 'S': return 'Subsequente';
                case 'P': return 'Pré-Natal';
                default: return '-'; 
            }
        },

        definir_tipo_consulta(tipo) {
            this.novo.tipo_consulta = tipo;
        },

        abrir (lista) {
            this.novo = { 
                procedimento: "", 
                tipo_consulta: 'C',
                medico: "",
                mesmo_horario: false, 
                data: "", 
                hora: "",
                id_unidade_operacao: _.get(
                    _.first(
                        lista.filter(item => item.marcacao && item.marcacao.id_atendimento)
                    ),
                    'id_unidade_operacao',
                    ''
                )
            };

            this.validate = false;
            
            this.lista = _.orderBy(
                lista.filter(item => item.marcacao && ( item.marcacao.id_atendimento || item.marcacao.ch_estado_marcacao == 'B' )) 
                    .map(item => { 
                        return { 
                            selecionado: true, 
                            id_marcacao: item.marcacao.id_marcacao,
                            id_paciente: item.marcacao.id_paciente,
                            id_cadastro_temporario: item.marcacao.id_cadastro_temporario,
                            id_plano: item.marcacao.id_plano,
                            id_operadora: item.marcacao.plano.id_operadora,
                            id_unidade_operacao: item.marcacao.id_unidade_operacao,
                            nome_paciente: item.marcacao.paciente ? item.marcacao.paciente.st_nome : item.marcacao.cadastro_temporario.st_nome,
                            nome_procedimento: item.marcacao.procedimento.search,
                        }
                    }),
                'nome_paciente'
            );

            $('#marcarBlocoModal').modal('show')
        },

        marcar() {

            if ( !confirm('Confirma realizar a marcação em bloco dos pacientes selecionados?') ) { 
                return;
            }
            
            this.$util.atualizar(this, { 
                service: 'agendas',
                func: 'marcar_bloco',
                dados: { 
                    id_procedimento: this.novo.procedimento.id_procedimento,
                    tipo_consulta: this.novo.tipo_consulta,
                    id_medico: this.novo.medico.id_pessoa,
                    data: this.novo.data,
                    hora: this.novo.hora,
                    mesmo_horario: this.novo.mesmo_horario,
                    lista: this.lista.filter(item => item.selecionado).map(item => { 

                        let retorno = { 
                            id_marcacao: item.id_marcacao,
                            id_paciente: item.id_paciente,
                            id_plano: item.id_plano,
                            id_operadora: item.id_operadora,
                            id_unidade_operacao: this.novo.id_unidade_operacao,
                            dt_inicio_original: item.dt_inicio, 
                            id_procedimento_original: item.id_procedimento, 
                        };

                        if ( !item.id_paciente && item.id_cadastro_temporario ) { 
                            retorno.id_cadastro_temporario = item.id_cadastro_temporario;
                        }

                        return retorno;
                    })
                },
                modal: 'marcarBlocoModal',
                toast: true, 
                callback: res => {
                    console.log('res', res);
                    this.$emit('refresh');
                }
            });

        }

    }

}
</script>
